import React from "react";

const ImageComponent: React.FC<{image: string, imageStyle?: object}> = ({image, imageStyle = {}}) => {
    return (
        <img src={image} style={{height: 450, ...imageStyle}} />
    )
};

export default ImageComponent